
import { useCallback } from 'react';
import { ComposeDraft } from '../types';

export const useEmailComposeMethods = (
  setComposeDraft: React.Dispatch<React.SetStateAction<ComposeDraft>>
) => {
  const updateComposeDraft = useCallback((draft: Partial<ComposeDraft>) => {
    setComposeDraft(prev => ({ ...prev, ...draft }));
  }, [setComposeDraft]);

  const resetComposeDraft = useCallback(() => {
    setComposeDraft({
      to: '',
      cc: '',
      bcc: '',
      subject: '',
      body: '',
      attachments: []
    });
  }, [setComposeDraft]);

  return {
    updateComposeDraft,
    resetComposeDraft,
  };
};
